export const defaultOptions_Homologacao = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: '55%',
      endingShape: 'rounded',
    },
  },
  dataLabels: {
    enabled: true,
  },
  stroke: {
    show: true,
    width: 2,
    colors: ['transparent'],
  },

  xaxis: {
    title: {
      text: 'Cooperativa',
    },
    categories: ['Cooperativa A', 'Cooperativa B', 'Cooperativa C'],
  },
  yaxis: {
    title: {
      text: 'Qtd. Homologações',
    },
  },
  fill: {
    opacity: 1,
  },
};

export const defaultOptions_Homologacao_Completo = {
  chart: {
    type: 'bar',
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: '60%',
      endingShape: 'rounded',
    },
  },
  dataLabels: {
    enabled: true,
  },
  stroke: {
    show: true,
    width: 2,
    colors: ['transparent'],
  },

  xaxis: {
    title: {
      text: 'Tempo',
    },
    categories: ['30MIN', '1 hora', '5 horas', 'Mais de 5 horas'],
  },

  fill: {
    opacity: 1,
  },
};

export const defaultOptions_Homologacao_Parceiro = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: '55%',
      endingShape: 'rounded',
    },
  },
  dataLabels: {
    enabled: true,
  },
  stroke: {
    show: true,
    width: 2,
    colors: ['transparent'],
  },

  xaxis: {
    title: {
      text: 'Convênios',
    },
    categories: ['Layout V4', 'Layout V5', 'Layout V4'],
  },
  yaxis: {
    title: {
      text: 'Qtd. Homologações',
    },
  },
  fill: {
    opacity: 1,
  },
};

export const defaultOptions_PercentualPendencias = {
  chart: {
    width: 380,
    type: 'pie',
    toolbar: {
      show: true,
      offsetX: 0,
      offsetY: 0,
      tools: {
        download: true,
      },
    },
  },
  labels: ['Cooperativa A'],
  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: {
          width: 300,
        },
        legend: {
          position: 'bottom',
        },
      },
    },
  ],
};
export const defaultOptions_PrincipaisErros = {
  chart: {
    width: 380,
    type: 'pie',
    toolbar: {
      show: true,
      offsetX: 0,
      offsetY: 0,
      tools: {
        download: true,
      },
    },
  },
  labels: ['Mensagem de Erro A'],
  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: {
          width: 300,
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          floating: true,
        },
      },
    },
  ],
};
